import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  CircularProgress
} from '@material-ui/core';

import eyeIcon from 'core/assets/svg/view.svg';
import { useToast } from 'core/components/toast';
import { dateTimeFormatter } from 'core/helpers/formatters';

import useStyles from './offer-document-list.styles';

const OfferDocumentList = ({ documents, onDownload, loading }) => {
  const classes = useStyles();

  const toast = useToast();

  const handleDownload = async (path) => {
    try {
      await onDownload(path);
    } catch (error) {
      toast.notify({
        type: 'error',
        message: 'Failed to download document'
      });
    }
  };

  const formatDate = (dateString) => {
    try {
      return dateTimeFormatter(new Date(dateString));
    } catch (error) {
      return 'Invalid date';
    }
  };

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress size={24} />
        <Typography variant="body2" className={classes.loadingText}>
          Loading documents...
        </Typography>
      </div>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <div className={classes.emptyState}>
        <Typography variant="body2" className={classes.emptyText}>
          No documents have been uploaded to this offer yet
        </Typography>
      </div>
    );
  }

  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.headerCell}>FILE NAME</TableCell>
          <TableCell className={classes.headerCell}>UPLOADED</TableCell>
          <TableCell className={classes.headerCell}>ACTIONS</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {documents.map((document) => {
          return (
            <TableRow key={document.id} className={classes.tableRow}>
              <TableCell className={classes.fileNameCell}>
                <div className={classes.fileNameContainer}>
                  <span className={classes.fileName}>{document.fileName}</span>
                </div>
              </TableCell>
              <TableCell className={classes.cell}>
                <div className={classes.uploadInfo}>
                  <div>{formatDate(document.uploadedAt)}</div>
                </div>
              </TableCell>
              <TableCell className={classes.actionsCell}>
                <div className={classes.actions}>
                  <IconButton
                    aria-label="download"
                    onClick={() => handleDownload(document.id)}
                    className={classes.actionButton}
                    size="small"
                  >
                    <img src={eyeIcon} alt="open" />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

OfferDocumentList.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      uploadedAt: PropTypes.string.isRequired
    })
  ),
  onDownload: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

OfferDocumentList.defaultProps = {
  documents: [],
  loading: false
};

export default OfferDocumentList;
